<template>
<div class="card">
    <div class="card-header">
        <p class="card-header-title">Import Teachers/Supervisors from excel (xlsx)</p>
    </div>
    <div class="card-content" v-show="step == 1">
        <div class="content">            
            <loading :active.sync="isLoading" 
                :can-cancel="false" 
                :is-full-page="true">
            </loading>                           
            <b-field class="file">                      
                <b-upload v-model="file">
                    <a class="button is-primary">
                        <i class='upload icon'></i>
                        <span>Import teachers/supervisors from excel</span>
                    </a>
                </b-upload>
                <span class="file-name" v-if="file">{{ file.name }}</span>
                <b-select placeholder="Import option" id="importOption"  v-model="importOption">
                    <option value="1">Add only new teachers/supervisors</option>
                    <option value="2">Remove all teachers/supervisors and insert teachers/supervisors from excel</option>
                </b-select>
                <button class='button is-info' v-on:click="uploadExcel()">
                    Upload now
                </button>
            </b-field>  
            <a class="button is-warning" v-on:click="downloadTemplate()">Download Excel (xlsx) template</a>                       
        </div>
    </div>
    <div class="card-content" v-show="step == 2">
        <div class="content">            
            <loading :active.sync="isLoading1" 
                :can-cancel="false" 
                :is-full-page="true">
            </loading>
            <table class="table">
                <thead>
                    <tr>
                    <th>Your field titles</th>
                    <th>Preview</th>
                    <th>Assign to field</th>
                    </tr>
                    <tr v-for="(dataPreview,index) in dataPreviewList" :key="dataPreview.headers">
                        <td>{{ dataPreview.headers }}</td>
                        <td>{{ dataPreview.sample }}</td>
                        <td>
                            <b-select :name="'selectedField' + index" v-model="systemField[index]" expanded>
                                <option value="1">First Name</option>
                                <option value="2">Last Name</option>
                                <option value="3">E-mail</option>
                                <option value="-1">-Don't Import-</option>
                            </b-select>
                        </td>
                    </tr>
                    <tr><td></td><td></td><td>
                        <b-button type='is-info' v-on:click="goToStep3()" expanded>
                            Next
                        </b-button>
                    </td></tr>
                </thead>
            </table>
        </div>
    </div>
</div>


</template>

<script>
import axios from 'axios'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { ToastProgrammatic as Toast } from 'buefy'
const helper = require("../../../../config/helper")

export default {
    props: ['schoolID'],
    components: {
        Loading
    },
    data() {
        return {
            isLoading: false,
            isLoading1: false,
            input: {
                firstName: '',
                lastName: '',
                email: ''
            },
            result: "",
            file: null,
            importOption: 1,
            step: 1,
            excelData: [],
            dataPreviewList: [],
            selectedField: [],
            systemField: []
        };
    },
    computed:{
    },
    created() {
    },
    methods: {
        uploadExcel(){
            let self = this
            console.log("Entering uploadExcel")

            if (this.file != null){

                var fileExtension = helper.getExtension(this.file.name)
                console.log("fileExtension: " + fileExtension)

                if (fileExtension != "xlsx"){
                    Toast.open({
                        message: "Sorry, you can only upload Excel (xlsx) file.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    return false;
                }

                var fileSize = this.file.size
                console.log("fileSize: " + fileSize)

                if (fileSize > 1000000){
                    Toast.open({
                        message: "Sorry, you can only upload file not more than 1MB.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                    return false;
                }
            
                if (this.importOption != 1){

                    this.$swal({
                        title: "Are you sure?",
                        text: "All teachers & its associated data will be removed first, then only the teachers inside the excel file will be processed. This will also make any current teachers QR tags no longer usable. To continue, enter 'CONFIRM REMOVE ALL TEACHERS' in the text field below and press OK",
                        input: 'text',
                        showCancelButton: true,
                        inputValidator: (value) => {
                            if (value == "CONFIRM REMOVE ALL TEACHERS"){
                                console.log("ok continue processing the excel")                                

                                self.isLoading = true;

                                let formData = new FormData();                
                                formData.append('token', localStorage.getItem('jwtTokenV2'));
                                formData.append('email', localStorage.getItem('email'));
                                formData.append('file', this.file);

                                axios.post(process.env.MY_URL + '/teachersV2/import',
                                    formData, {
                                        headers: {
                                            'Content-Type': 'multipart/form-data'
                                        }
                                    }
                                ).then(response => {
                                    console.log('SUCCESS!!');
                                    console.log("165 response.data")
                                    console.log(response.data)
                                    self.isLoading = false
                                    if (response.data.success == true) {
                                        self.dataPreviewList = response.data.dataPreviewList
                                        self.excelData = response.data.excelData
                                        self.step = 2

                                        this.dataPreviewList.forEach((dataPreview, index) => {
                                            this.$set(this.systemField, index, (index+1).toString())
                                        })
                                    } else {
                                        Toast.open({
                                            message: response.data.msg,
                                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                            duration: 10000
                                        })
                                        this.isLoading = false
                                        console.log(response.data.msg)
                                    }
                                })
                                .catch(e => {
                                    console.log(e)
                                    Toast.open({
                                        message: e.response,
                                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                        duration: 10000
                                    })
                                    this.isLoading = false
                                });
                                
                            }else{
                                alert("You entered the wrong input. Import is not processed.")
                                return false;
                            }
                        }
                    })

                }else{
                    self.isLoading = true;

                    let formData = new FormData();                
                    formData.append('token', localStorage.getItem('jwtTokenV2'));
                    formData.append('email', localStorage.getItem('email'));
                    formData.append('file', this.file);

                    axios.post(process.env.MY_URL + '/teachersV2/import',
                        formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then(response => {
                        console.log('SUCCESS!!');
                        console.log("218 response.data")
                        console.log(response.data)
                        self.isLoading = false
                        if (response.data.success == true) {
                            self.dataPreviewList = response.data.dataPreviewList
                            self.excelData = response.data.excelData
                            self.step = 2

                            this.dataPreviewList.forEach((dataPreview, index) => {
                                this.$set(this.systemField, index, (index+1).toString())
                            })
                        } else {
                            Toast.open({
                                message: response.data.msg,
                                type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                                duration: 10000
                            })
                            this.isLoading = false
                            console.log(response.data.msg)
                        }
                    })
                    .catch(e => {
                        console.log(e)
                        Toast.open({
                            message: e.response,
                            type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            duration: 10000
                        })
                        this.isLoading = false
                    });
                }

            }else{
                Toast.open({
                    message: "Please select the excel file you want to upload!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 5000
                })
                return false;
            }
        },
        goToStep3(){
            console.log("109 entering goToStep3")
            let self = this

            var isFirstNameSet = false
            var isLastNameSet = false
            var isEmailSet = false
            var firstNameCount = 0
            var lastNameCount = 0
            var emailCount = 0

            var assignedFields = []

            console.log("201 entering goToStep3")
            this.dataPreviewList.forEach((dataPreview, index) => {
               console.log("ye: ")
               console.log(this.systemField[index])

               assignedFields.push(this.systemField[index])

                if (this.systemField[index] == 1){
                   isFirstNameSet = true;
                   firstNameCount = firstNameCount + 1
                }
                if (this.systemField[index] == 2){
                   isLastNameSet = true;
                   lastNameCount = lastNameCount + 1
                }
                if (this.systemField[index] == 3){
                   isEmailSet = true;
                   emailCount = emailCount + 1
                }
            })

            console.log("firstNameCount: " + firstNameCount)
            console.log("lastNameCount: " + lastNameCount)
            console.log("emailCount: " + emailCount)

            if (firstNameCount < 1){
                Toast.open({
                    message: "You need to assign the first name field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (firstNameCount > 1){
                Toast.open({
                    message: "You cannot assign more than 1 field to the first name field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (lastNameCount > 1){
                Toast.open({
                    message: "You cannot assign more than 1 field to the last name field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (emailCount < 1){
                Toast.open({
                    message: "You need to assign the e-mail field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            if (emailCount > 1){
                Toast.open({
                    message: "You cannot assign more than 1 field to the e-mail field!",
                    type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    duration: 3000
                })
                return false;
            }
            console.log("311 Everything ok?")
            console.log("312 excelData.length: " + self.excelData.length)
            console.log(self.excelData[0].length)
            console.log(self.excelData[0])
            console.log("312 imini")
            console.log(self.excelData)
            console.log("312 assignedFields.length: " + assignedFields.length)
            console.log(assignedFields)

            //now let's replace the header (first) row
            for (var i = 0; i < self.excelData[0].length; i++){
                var j = i + 1;
                self.excelData[0][i] = assignedFields[i] + ""
            }
            console.log(self.excelData[0].length)
            console.log(self.excelData[0])            
                
            self.isLoading = true;
           
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/teachersV2/import2', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                excelData: self.excelData,
                assignedFields: assignedFields,
                importOption: self.importOption
            })
            .then(response => {
                console.log("293 response.data.length: " + response.data.length)
                this.file = null
                self.isLoading = false
                
                Toast.open({
                    color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                    message: response.data.msg,
                    type: 'is-success',
                    duration: 15000
                })                
                
                this.step = 1
                this.$parent.getData()

            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
                if (e.response.status === 401) {
                    Toast.open({
                        message: "Unauthorized access. Please re-login.",
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                } else {
                    Toast.open({
                        message: 'Error: ' + e.response.data.msg,
                        type: 'is-danger', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                        duration: 5000
                    })
                }
            })
        },
        downloadTemplate(){
            var downloadLink = "https://" + window.location.hostname + "/downloads/template_teachers.xlsx";
            console.log("downloadLink: " + downloadLink)
            window.open(downloadLink,"_blank")
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Manage/Teachers/ImportExcelForm.vue